<div class="row justify-content-center">
        @for(data of clients_logo;track $index){
        <div class="{{brand_class}}">
        <img src="{{data.image}}" class="avatar avatar-ex-sm" alt="">
    </div>
}
</div>